import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-image-dialog",
  templateUrl: "./image-dialog.component.html",
  styleUrls: ["./image-dialog.component.scss"],
  standalone: true,
  imports: [CommonModule, ButtonModule, ProgressSpinnerModule],
})
export class ImageDialogComponent implements OnInit {
  imageUrl?: string;
  altText?: string;
  imageLoaded = false;
  loadError = false;

  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);

  ngOnInit(): void {
    this.imageUrl = this.config.data?.imageUrl;
    this.altText = this.config.data?.altText || $localize`:@@image_dialog_alt_text_default:Visualisation de l'image`;
    if (!this.imageUrl) {
      console.error("ImageDialogComponent: No image URL provided.");
      this.loadError = true;
    }
  }

  onImageLoad(): void {
    this.imageLoaded = true;
    this.loadError = false;
  }

  onImageError(): void {
    console.error("ImageDialogComponent: Failed to load image from URL:", this.imageUrl);
    this.imageLoaded = false;
    this.loadError = true;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
